import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";

const Terms = () => {
  const [searchParams] = useSearchParams();
  const isModule = searchParams.get("app");

  return (
    <>
      {isModule === "true" ? [] : <HeaderLayout />}
      <div>
        <div
          style={{
            padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2 align="center">Terms & Conditions</h2>
          <p>
            By using the Bonoxi website and services, you agree to the following
            terms and conditions.
          </p>

          <h3>1. Use of Service</h3>
          <p>Bonoxi provides tools to:</p>
          <ul>
            <li>
              Convert Word, Excel, PowerPoint, images, and rich/plain text into
              PDF.
            </li>
            <li>
              Convert PDF files into Word, Excel, PowerPoint, or image formats.
            </li>
            <li>
              Merge, split, rearrange, compress, OCR, e-sign, and
              password-protect PDF files.
            </li>
            <li>
              Generate QR codes for websites, text, locations, brands/logos,
              social profiles, files, digital business cards (vCard), products,
              and messages — with optional password protection.
            </li>
          </ul>
          <p>These services are intended for lawful use only.</p>

          <h3>2. User Responsibility</h3>
          <p>You are solely responsible for:</p>
          <ul>
            <li>
              The content, files, photos, logos, and other media you upload or
              input.
            </li>
            <li>
              Ensuring your documents, images, and other media do not violate
              copyright, contain sensitive data you are not authorized to
              share, or infringe on any third party&apos;s rights.
            </li>
            <li>
              Downloading your results before the session ends, or before any
              associated retention period expires.
            </li>
          </ul>
          <p>
            By uploading a file, photo, logo, or other media, you confirm that
            you have the right to share it and grant Bonoxi permission to
            process it solely to deliver the conversion or QR code you
            requested. See our{" "}
            <a href="/privacy">Privacy Policy</a> for details on how uploaded
            media is accessed, used, and deleted.
          </p>

          <h3>3. Limitation of Liability</h3>
          <ul>
            <li>Bonoxi is not liable for loss of files or data.</li>
            <li>
              Bonoxi is not liable for errors in conversion or QR code
              generation.
            </li>
            <li>
              Bonoxi is not liable for any damages resulting from the use of our
              services.
            </li>
          </ul>

          <h3>4. Intellectual Property</h3>
          <p>
            All website content, branding, and features are the property of
            Bonoxi and cannot be copied or reused without permission.
          </p>

          <h3>5. Service Availability</h3>
          <p>
            We reserve the right to modify, suspend, or discontinue our services
            without notice at any time.
          </p>

          <h3>6. Termination</h3>
          <p>
            We may restrict access or terminate accounts that violate these
            terms.
          </p>

          <h3>7. Data Deletion</h3>
          <p>
            You may request deletion of your account and any associated files,
            QR codes, or documents at any time by emailing{" "}
            <a href="mailto:support@bonoxi.com">support@bonoxi.com</a> with the
            subject line &quot;Data Deletion Request&quot;. See our{" "}
            <a href="/privacy">Privacy Policy</a> for the full process and
            timeline.
          </p>

          <h3>8. Governing Law</h3>
          <p>
            These Terms are governed by and construed in accordance with the
            laws of your country/state.
          </p>

          <p>
            For any queries, reach out to:{" "}
            <a href="mailto:support@bonoxi.com">support@bonoxi.com</a>
          </p>
          <hr />
          <p>
            <strong>Effective Date:</strong> May 15, 2025
            <br />
            <strong>Last Updated:</strong> September 28, 2026
          </p>
        </div>
      </div>
      {isModule === "true" ? [] : <FooterLayout />}
    </>
  );
};

export default Terms;
